import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Members from './pages/Members';
import MemberHotspot from './pages/MemberHotspot';
import Partners from './pages/Partners';
import SiteContent from './pages/SiteContent';
import MotorTypes from './pages/MotorTypes';
import MemberProfileEdit from './pages/MemberProfileEdit';
import Events from './pages/Events';
import Messages from './pages/Messages';
import Checkpoints from './pages/Checkpoints';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/members"
          element={
            <ProtectedRoute>
              <Members />
            </ProtectedRoute>
          }
        />
        <Route
          path="/members/:id/hotspot"
          element={
            <ProtectedRoute>
              <MemberHotspot />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events"
          element={
            <ProtectedRoute>
              <Events />
            </ProtectedRoute>
          }
        />
        <Route
          path="/messages"
          element={
            <ProtectedRoute>
              <Messages />
            </ProtectedRoute>
          }
        />
        <Route
          path="/checkpoints"
          element={
            <ProtectedRoute>
              <Checkpoints />
            </ProtectedRoute>
          }
        />
        <Route
          path="/partners"
          element={
            <ProtectedRoute>
              <Partners />
            </ProtectedRoute>
          }
        />
        <Route
          path="/site-content"
          element={
            <ProtectedRoute>
              <SiteContent />
            </ProtectedRoute>
          }
        />
        <Route
          path="/motor-types"
          element={
            <ProtectedRoute>
              <MotorTypes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/members/:id/edit-profile"
          element={
            <ProtectedRoute>
              <MemberProfileEdit />
            </ProtectedRoute>
          }
        />
        <Route index element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;
